import React from "react";
import '../css/LoadingSpinner.css';


const LoadingSpinner = () => {
  return (
    <span className="LoadingSpinner"></span>
  );
};

export default LoadingSpinner;
